import { api } from '../../shared/api/client';
import { adaptSavedEquipment } from '../../shared/api/adapters';
import type { ApiSavedEquipment } from '../../shared/types/api';
import type { SavedEquipment, EquipmentKind, WeightClass } from '../../shared/types/app';

export async function fetchSavedEquipment(): Promise<SavedEquipment[]> {
  const res = await api.get<ApiSavedEquipment[] | { data: ApiSavedEquipment[] }>('/api/v1/users/me/equipment');
  const list = Array.isArray(res) ? res : res.data;
  return list.map(adaptSavedEquipment);
}

export async function addSavedEquipment(item: {
  label: string;
  equipmentKind: EquipmentKind;
  equipmentDesc?: string;
  weightClass: WeightClass;
  make: string;
  model: string;
  estimatedWeight?: number | null;
  photoUrl?: string | null;
}): Promise<SavedEquipment> {
  const res = await api.post<ApiSavedEquipment>('/api/v1/users/me/equipment', item);
  return adaptSavedEquipment(res);
}

export async function deleteSavedEquipment(id: string) {
  return api.delete(`/api/v1/users/me/equipment/${id}`);
}
